import httpService from './http.service';

const fetchParkingPlaces = () => httpService
    .get('/parkingPlace')
    .then(({data}) => data)
    .catch((err) => Promise.reject(err));

export default {
    fetchParkingPlaces,
};